import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Onboarding({ onDone }) {
  const qc = useQueryClient();
  const [slots, setSlots] = useState("");
  const [saving, setSaving] = useState(false);
  const total = slots ? Number(slots) * 20 : 0;

  const activate = async () => {
    const n = Number(slots);
    if (!n || n < 1) return toast.error("Δηλώστε αριθμό θέσεων");
    setSaving(true);
    try {
      await api.post("/subscription/activate", { slots: n });
      await qc.invalidateQueries();
      toast.success("Ο λογαριασμός ενεργοποιήθηκε");
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Σφάλμα");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6" data-testid="onboarding">
      <div className="w-full max-w-md rounded-sm border border-border bg-white p-8 shadow-sm">
        <span className="inline-flex rounded-sm bg-[#234E7D] px-3 py-2">
          <img src="/navipark-logo.png" alt="NAVIPARK" className="h-auto w-full max-w-[260px]" />
        </span>
        <h1 className="mt-4 font-head text-2xl font-bold text-[#234E7D]">Καλώς ήρθατε στο NAVIPARK</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Δηλώστε τον αριθμό των θέσεων του parking σκαφών σας για να ξεκινήσετε. Η ετήσια συνδρομή είναι 20€ ανά θέση.
        </p>
        <div className="mt-6">
          <Label className="text-xs text-muted-foreground">Αριθμός θέσεων</Label>
          <Input type="number" min="1" value={slots} onChange={(e) => setSlots(e.target.value)} className="mt-1 rounded-sm" placeholder="π.χ. 30" data-testid="onboarding-slots" />
        </div>
        <div className="mt-4 flex items-center justify-between rounded-sm bg-[#EFF6FF] p-3 text-sm">
          <span className="text-muted-foreground">Ετήσια συνδρομή</span>
          <span className="font-head text-lg font-bold text-[#0044CC]" data-testid="onboarding-total">{total.toLocaleString("el-GR")} €</span>
        </div>
        <Button onClick={activate} disabled={saving} className="mt-5 w-full rounded-sm bg-[#0055FF] hover:bg-[#0044CC]" data-testid="onboarding-activate">
          {saving ? "..." : "Ενεργοποίηση & είσοδος"}
        </Button>
        <p className="mt-2 text-center text-[11px] text-muted-foreground">Στην παρούσα φάση η πρόσβαση δίνεται χωρίς πληρωμή.</p>
      </div>
    </div>
  );
}
